import classNames from "classnames"
import SvgImages from "components/library/SvgImages"
import UserRoleValidator from "components/user/UserRoleValidator"
import { SORT_BY, SORT_TYPES } from "hooks/useSortScenarioList"
import Translate from "lang/Translate"

interface CaseListHeaderProps {
	handleSortToggle: (columnId: string) => void,
	sortIndex: number,
	sortBy: string
}

interface SortColumnByTypeProps extends CaseListHeaderProps {
	children: React.ReactNode,
	idx: string
}

const SortColumnByType = ({ children, handleSortToggle, sortIndex, idx, sortBy }: SortColumnByTypeProps) => {
	return (
		<div className={classNames({ "is-sorted": SORT_TYPES[sortIndex] })} >
			<div className="sort-label" onClick={() => handleSortToggle(idx)}>
				{children}
			</div>
			<SvgImages wrapperClassNames={classNames("sort-icon flex-center", { "desc-mode": SORT_TYPES[sortIndex] === "desc", "is-active": idx === sortBy })} imgKey={"sortArrow"} />
		</div>
	)
}

const CaseListHeader = (props: CaseListHeaderProps) => {
	return (
		<div className="border-bottom p-4">
			<div className="case-list-header flex-center header-row">
				<SortColumnByType {...props} idx={SORT_BY.NAME}>
					<Translate text="Labels.scenario" />
				</SortColumnByType>
				<SortColumnByType {...props} idx={SORT_BY.CASE_STUDY}>
					<div>#</div>
				</SortColumnByType>
				<SortColumnByType {...props} idx={SORT_BY.LEVEL}>
					<div><Translate text="Labels.level" /></div>
				</SortColumnByType>
				<SortColumnByType {...props} idx={SORT_BY.PROVINCE}>
					<div><Translate text="Labels.provinceColumn" /></div>
				</SortColumnByType>
				<SortColumnByType {...props} idx={SORT_BY.TAX_PAYER}>
					<div><Translate text="Labels.taxPayerName" /></div>
				</SortColumnByType>
				<UserRoleValidator validatorName="SCENARIO_PUBLISH">
					<SortColumnByType {...props} idx={SORT_BY.PUBLISHED}>
						<div><Translate text="Labels.publish" /></div>
					</SortColumnByType>
				</UserRoleValidator>
				<div></div>
			</div>
		</div>
	)
}

export default CaseListHeader